export enum EditOptionEnum {
  Transaction,
  Nickname,
  Share,
  ConvertToAgent,
  Commission,
}
